import { InputSwitch } from 'primereact/inputswitch';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors/FieldWithErrors';

function TwoFactorAuthDelivery(): JSX.Element {
  const { t } = useTranslation();

  return (
    <FieldWithErrors
      name="two_factor_auth_delivery"
      label={t('OTP code on delivery')}
    >
      <Controller
        name="two_factor_auth_delivery"
        render={({ field }) => (
          <InputSwitch
            {...field}
            checked={Boolean(field.value)}
            inputId={field.name}
          />
        )}
      />
    </FieldWithErrors>
  );
}

export default TwoFactorAuthDelivery;
